module.exports = __webpack_public_path__ + "static/media/pork_stamp_fr.0966f3fe.svg";